import React from 'react'

import { Tooltip } from 'antd'
import { connect } from 'react-redux'
import { getTranslate } from 'react-localize-redux'

import { EUROPEAN_DATE } from '../../../utils/momentjs'

const mapStateToProps = state => ({ t: getTranslate(state.locale) })

const WeekNumberWithTooltip = ({ className, style, t, week }) => {
  const getTitle = () => (
    t('Week') + ' ' + t('from') + ' ' +
    week.startDate.format(EUROPEAN_DATE) +
    ' ' + t('to') + ' ' +
    week.endDate.format(EUROPEAN_DATE)
  )

  return (
    <Tooltip title={getTitle}>
      <th key={`col_${week.number}`} className={className} style={style}> {week.number} </th>
    </Tooltip>
  )
}

export default connect(mapStateToProps)(WeekNumberWithTooltip)
